<template>
  <div class='my-offers'>
    <vue-headful title='My Offers' />
    <h1>MY OFFERS</h1>
    <hr />

    <offers-not-found v-if='offersUnavailable' />
    <div v-else>
      <offers-loader v-if='apiLoading' />
      <offers-list v-if='apiLoaded' :offers='offers' />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';
import OffersList from '@/components/HomebuyerOffers/OffersList.vue';
import OffersLoader from '@/components/Loaders/OffersLoader.vue';
import OffersNotFound from '@/components/HomebuyerOffers/OffersNotFound.vue';

export default {
  name: 'offers',
  components: { OffersLoader, OffersList, OffersNotFound },
  extends: BaseViewComponent,
  computed: {
    ...mapState('HomebuyerOffers', {
      offers: state => state.offers,
    }),
    offersUnavailable() {
      return false;
    },
  },
  mounted() {
    this.initialHydration([
      this.$store.dispatch('HomebuyerOffers/loadOffers', {
        location: 'homebuyer_offer_portal',
        referrer: this.referrer,
      }),
    ]);
  },
  props: {
    referrer: String,
  },
};
</script>

<style lang='scss' scoped>
@import '../../styles/vars/theme';

hr {
  border: solid 2px $theme-color-primary;
  margin-top: 40px;
  width: 100%;
}

.my-offers {
  padding: 50px;
}

@media all and (max-width: 655px) {
  .my-offers {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
